<ece-btn-icon
  [title]="hintText | i18n"
  (click)="openHelp()"
  [icon]="'help'">
</ece-btn-icon>

